module.exports = __webpack_public_path__ + "img/paihang_bg.de8c354f.png";